import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { ColumnChooserService, FilterService, GridModule, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MyDatePickerModule } from 'mydatepicker';
import { EvvtimesheetEditComponent } from './evvtimesheet-edit/evvtimesheet-edit.component';
import { EvvtimesheetComponent } from './evvtimesheet.component';
import { EvvtimesheetRoutingModule } from './evvtimesheet-routing.module';
import { EvvtimesheetListComponent } from './evvtimesheet-list/evvtimesheet-list.component';
import { DropDownListAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { EvvTimesheetDateListService } from './evvtimesheet-list/evvtimesheet-listdata.service';


@NgModule({
  declarations: [EvvtimesheetComponent,EvvtimesheetEditComponent,EvvtimesheetListComponent],
imports: [
  CommonModule,
  FormsModule,
  NgSelectModule,
  GridModule,
  ReactiveFormsModule,
  MultiselectDropdownModule,
  NumericTextBoxModule,
  NumericTextBoxAllModule,
  NgxUiLoaderModule,
  MaskedTextBoxModule,
  MyDatePickerModule,
  DropDownListAllModule,
  EvvtimesheetRoutingModule,
],
providers: [ColumnChooserService,PageService,SortService,FilterService,ResizeService,EvvTimesheetDateListService],
})


export class EvvtimesheetModule { }
